import React from 'react'
import { Form } from 'semantic-ui-react'

const CustomizedNameField = ({ value, onChange, label, placeholder }) => {
  return (
    <Form.Input
      fluid
      required
      label={label}
      placeholder={placeholder}
      onChange={e => onChange(e.target.value)}
      value={value}
    />
  )
}

export default CustomizedNameField



// WEBPACK FOOTER //
// ./src/components/restaurants/fields/customizedNameField.js